var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPipedrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D4145",
    d: "M8 55.904h47.902V8.148H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M34.103 20.12c3.362 0 5.62 2.892 5.62 7.196 0 4.904-2.865 7.097-5.717 7.097-3.83 0-5.574-3.653-5.574-7.05 0-5.34 2.93-7.243 5.67-7.243zm1.351-6.281c-4.004 0-6.314 1.873-7.435 3.111-.13-1.065-.835-2.365-3.583-2.365H17.73v5.97h3.179c.414 0 .564.23.564.642v28.464h7.485V38.18c1.109 1.018 2.939 2.42 6.256 2.42 6.96 0 11.506-5.5 11.506-13.378 0-8.003-4.394-13.38-11.265-13.38v-.003z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjR2NjRIMHoiLz48cGF0aCBmaWxsPSIjM0Q0MTQ1IiBkPSJNOCA1NS45MDRoNDcuOTAyVjguMTQ4SDh6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTM0LjEwMyAyMC4xMmMzLjM2MiAwIDUuNjIgMi44OTIgNS42MiA3LjE5NiAwIDQuOTA0LTIuODY1IDcuMDk3LTUuNzE3IDcuMDk3LTMuODMgMC01LjU3NC0zLjY1My01LjU3NC03LjA1IDAtNS4zNCAyLjkzLTcuMjQzIDUuNjctNy4yNDN6bTEuMzUxLTYuMjgxYy00LjAwNCAwLTYuMzE0IDEuODczLTcuNDM1IDMuMTExLS4xMy0xLjA2NS0uODM1LTIuMzY1LTMuNTgzLTIuMzY1SDE3LjczdjUuOTdoMy4xNzljLjQxNCAwIC41NjQuMjMuNTY0LjY0MnYyOC40NjRoNy40ODVWMzguMThjMS4xMDkgMS4wMTggMi45MzkgMi40MiA2LjI1NiAyLjQyIDYuOTYgMCAxMS41MDYtNS41IDExLjUwNi0xMy4zNzggMC04LjAwMy00LjM5NC0xMy4zOC0xMS4yNjUtMTMuMzh2LS4wMDN6Ii8+PC9nPjwvc3ZnPg==";
export { SvgPipedrive as ReactComponent };